// extracted by mini-css-extract-plugin
module.exports = {"green-button":"FormsTable_green-button__1oQD5"};